module.exports = __webpack_public_path__ + "img/icon2.564ffe17.png";